import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle';

export function NotFound() {
  useDocumentTitle('Not Found — Skiffs');
  return (
    <article className="skf-card">
      <p className="skf-eyebrow">404</p>
      <h1 className="skf-title">Off the chart.</h1>
      <p className="skf-subtitle">That page doesn&rsquo;t exist. Maybe head back home?</p>
      <Link className="skf-cta" to="/">
        Back to Skiffs
      </Link>
    </article>
  );
}
